<template>
	<div>
		<v-card-title>
			{{ $vuetify.lang.t('$vuetify.views.userGroups.title') }}
		</v-card-title>
		<v-card-text>
			<search
			class="mb-4"
				v-model.lazy="search"
				:placeholder="$vuetify.lang.t('$vuetify.views.userGroups.search')"
			/>
			<v-row v-if="groups && !loading" align="stretch">
				<v-col
					cols="6"
					md="4"
					lg="6"
					xl="6"
					v-for="(group, i) in groups"
					:key="'groups-' + i"
				>
					<v-card flat outlined class="wall-card mb-0 user-group-box h-100 pa-3">
						<v-card-text class="h-100 d-flex flex-column h-100">
							<div class="d-flex justify-content-center">
								<avatar :group="group" />
							</div>
							<div class="text-center mt-3">
								<div class="font-14 font-weight-bold grey--text text--darken-2">{{ group.name }}</div>
								<div class="mt-1 grey--text font-12">{{ group.users_count }} członków w grupie</div>
							</div>
							<div class="d-flex justify-content-center mt-auto">
								<router-link
									:to="{ name: 'Group', params: { id: group.id } }"
									class="text-decoration-none"
								>
									<v-btn
										elevation="0"
										color="accent"
										class="mt-5"
									>
										Przejdź do grupy
									</v-btn>
								</router-link>
							</div>
						</v-card-text>
					</v-card>
				</v-col>
			</v-row>
			<v-row v-if="loading" align="stretch">
				<v-col
					cols="6"
					md="4"
					lg="6"
					xl="6"
					v-for="i in 9"
					:key="'skeleton-' + i"
				>
					<v-skeleton-loader
						type="card"
						flat outlined class="wall-card mb-0 user-group-box "
					></v-skeleton-loader>
				</v-col>
			</v-row>
		</v-card-text>
	</div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import Avatar from "@/components/Avatar";
import Search from "@/components/top-bar/Search";
export default {
	name: "UserGroups",
	components: {
		Avatar,
		Search
	},
	data() {
		return {
			search: '',
			delayer: null,
			loading: false
		}
	},
	computed: {
		...mapGetters({
			groups: "groups/userGroups",
		}),
	},
	watch: {
		search: async function(v) {
			this.loading = true;
			await this.getGroups({
				params: {
					name: v
				}
			})
			this.loading = false;
		}
	},
	methods: {
		...mapActions('groups', [
			'getUserGroups'
		]),
		async getGroups(params = null) {
			this.loading = true;
			await this.getUserGroups({params});
			this.loading = false
		}
	},
	created() {
		this.getGroups();
	}
}
</script>

<style lang="scss">
.user-group-box {
	box-shadow: 0 2px 2px 0 rgba(58, 57, 76, 0.08) !important;
}
</style>
